import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import {
    AbstractControl,
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators
} from '@angular/forms';
import { GENDERS } from '../../../../../../environments/constants';
import { ContactInterface } from '../../../../../model/organisations/contact-interface';
import { VALIDATORS } from '../../../../../../environments/validators';
import { Subscription } from 'rxjs';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
import { OrganisationInterface } from 'src/app/model/organisations/organisation-interface';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { UtilService } from 'src/app/services/util-service/utilService';

@Component({
    selector: 'app-contact-form',
    templateUrl: './contact-form.component.html',
    styleUrls: ['./contact-form.component.css'],
    standalone: false
})
export class ContactFormComponent implements OnInit {
    @Input()
    public contactInput: ContactInterface;
    @Output()
    private done = new EventEmitter<ContactInterface>();
    @Output()
    private cancel = new EventEmitter<ContactInterface>();
    contactForm: UntypedFormGroup;

    contactName: AbstractControl;
    phoneNumber: AbstractControl;
    mobilePhoneNumber: AbstractControl;
    email: AbstractControl;
    website: AbstractControl;
    gender: AbstractControl;
    
    public genders = GENDERS;
    
    private contact: ContactInterface = {
        contactName: '',
        phoneNumber: '',
        mobilePhoneNumber: '',
        email: '',
        website: '',
        gender: ''
    };
    
    public contacts: ContactInterface[] = [];
    private activeItemSubscription: Subscription;

    constructor(private formbuilder: UntypedFormBuilder, private organisationService: OrganisationService,
        private dialogService: DialogService, private utilService: UtilService
    ) {}

    ngOnInit() {
        this.initialiseContactForm();
        this.contactName = this.contactForm.controls['contactName'];
        this.phoneNumber = this.contactForm.controls['phoneNumber'];
        this.mobilePhoneNumber = this.contactForm.controls['mobilePhoneNumber'];
        this.email = this.contactForm.controls['email'];
        this.website = this.contactForm.controls['website'];
        this.gender = this.contactForm.controls['gender'];
        this.activeItemSubscription =
        this.organisationService.activeItemObserver.subscribe(
            (orga: OrganisationInterface) => {
                if (!orga) {
                    return;
                }
                this.contacts = orga.contacts ?? [];
            }
        );
    }

    onSubmit() {
        if (this.isDuplicateEmail()) {
            this.dialogService.openDialog(
                'Speichern fehlgeschlagen',
                'Es existiert bereits ein Kontakt mit dieser E-Mail Adresse.'
            );
            return;
        }

        if (this.contactInput !== undefined) {
            this.contact.contactId = this.contactInput.contactId; 
        }

        this.contact.contactName = this.contactName.value;
        this.contact.phoneNumber = this.phoneNumber.value;
        this.contact.mobilePhoneNumber = this.mobilePhoneNumber.value;
        this.contact.email = this.email.value;
        this.contact.website = this.website.value;
        this.contact.gender = this.gender.value;
        this.done.emit(this.contact);
    }

    onCancel() {
        this.cancel.emit(this.contact);
        this.contactForm.reset();
    }

    initialiseContactForm() {
        this.contactForm = this.formbuilder.group({
            contactName: [
                this.contactInput === undefined
                    ? ''
                    : this.contactInput.contactName,
                Validators.required
            ],
            phoneNumber: [
                this.contactInput === undefined
                    ? ''
                    : this.contactInput.phoneNumber,  Validators.pattern(/^\+?[\d\s]{10,20}$/)
            ],
            mobilePhoneNumber: [
                this.contactInput === undefined
                    ? ''
                    : this.contactInput.mobilePhoneNumber,  Validators.pattern(/^\+?[\d\s]{10,20}$/)
            ],
            email: [
                this.contactInput === undefined ? '' : this.contactInput.email,
                VALIDATORS.email
            ],
            website: [
                this.contactInput === undefined ? '' : this.contactInput.website, VALIDATORS.website
            ],
            gender: [
                this.contactInput === undefined ? '' : this.contactInput.gender
            ]
        });
    }

    // TODO: Add contacts duplication check into backend service instead of frontend
    private isDuplicateEmail(): boolean {
        if (!this.email.value || !this.contacts || this.contacts.length === 0) {
            return false;
        }
        
        const emailToCheck = this.email.value.toLowerCase().trim();
        
        return this.contacts.some(contact => {
            if (this.contactInput && contact.contactId === this.contactInput.contactId) {
                return false;
            }
            
            return contact.email && contact.email.toLowerCase().trim() === emailToCheck;
        });
    }

    checkAndSetPhonenumber(isMobile: boolean = false): void {
        const control = isMobile ? this.mobilePhoneNumber : this.phoneNumber;

        const phoneValue = control.value.trim();
        if(isMobile === true) {
            this.mobilePhoneNumber.setValue(phoneValue, { emitEvent: false });
        } else {
            this.phoneNumber.setValue(phoneValue, { emitEvent: false });
        }

        if (!phoneValue) {
            return;
        }
    
        if (!this.utilService.validateInternationalPhone(phoneValue)) {
            control.setErrors({ invalidPhone: true });
        }
    }

    ngOnDestroy() {
        if (this.activeItemSubscription) {
            this.activeItemSubscription.unsubscribe();
        }
    }

    trimField(controlName: string) {
        const control = this.contactForm.get(controlName);
        if (control) {
            control.setValue(control.value?.trim());
        }
    }
}
